import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setClassName } from 'services/api/education';
import styled from 'styled-components';
import { fontFamilies } from "theme/fontConfig";

const Progress_bar = ({ bgcolor, progress, height, id, class_name,value,maxValue,infinite }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch()
  const Parentdiv = {
    height: height,
    width: '100%',
    backgroundColor: 'whitesmoke',
    borderRadius: 40,
  };

  const Childdiv = {
    height: '100%',
    maxWidth: '100%',
    width: `${infinite ? value > 0 ? 33.33 : 0 : progress}%`,
    backgroundColor: bgcolor,
    borderRadius: 40,
    textAlign: 'right',
  };

  const progresstext = {
    padding: 5,
    color: (progress > 100 && !infinite) ? '#FA3372' : '#4F4F4F',
    fontSize: infinite ? '16px' : '13px',
    fontWeight: '400',
    fontFamily: fontFamilies.primary,
    lineHeight: '19.5px',
  };

  const CustomViewButton = styled.div`
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    padding: 5px;
    background: #fff;
    color: #000;
    cursor: pointer;

    @media (min-width: 1900px) {
      right: 23%;
    }
    @media (min-width: 2500px) {
      right: 50%;
    }
  `;

  return (
    <div
      className="d-flex align-items-center"
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      style={{ position: 'relative' }}
    >
      <div style={{ width: '140px', display: 'flex', alignItems: 'center' }}>
        <div style={Parentdiv}>
          <div style={Childdiv}></div>
        </div>
        <span style={progresstext}>{value}</span> /
        {infinite ? (
          <span style={progresstext}>&#8734;</span>
          ) : (
            <span style={progresstext}>{maxValue}</span>
        )}
      </div>
      {/* {isTooltipVisible && (
        <CustomViewButton
          onClick={() => {
            dispatch(setClassName(class_name))
            history.push(`/class-participants/details/${id}`);
          }}
        >
          View
        </CustomViewButton>
      )} */}
    </div>
  );
};

export default Progress_bar;
